<sz-row-card class="drill-list-item" [variant]="variant()" [interactive]="true" (click)="onSelect()">
  <sz-ic-circle szRowLead [accent]="variant() === 'featured' ? 'lime' : 'ghost'">
    {{ drill().scoringShort }}
  </sz-ic-circle>
  <div class="drill-list-item__body">
    <div class="drill-list-item__name">{{ drill().name }}</div>
    <div class="drill-list-item__meta">
      <sz-type-pill [type]="drill().typeLabel === 'Live' ? 'Live' : 'Dry'" />
      <sz-score-chip [scoring]="drill().scoring" />
    </div>
  </div>
  <div szRowEnd class="drill-list-item__end">
    <sz-icon-button
      icon="star"
      size="sm"
      [variant]="drill().favorite ? 'lime' : 'default'"
      [ariaLabel]="'drills.listItem.favoriteToggle' | translate"
      (click)="onFavoriteClick($event)" />
    <sz-icon name="arrow-right" [size]="16" />
  </div>
</sz-row-card>
